export default __webpack_public_path__ + "static/media/contract.96976904.jpg";